export function remToPx(value) {
    return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
    return `${value / 16}rem`;
}

// export function responsiveFontSizes({ sm, md, lg }) {
//     return {
//         '@media (min-width:600px)': {
//             fontSize: pxToRem(sm),
//         },
//         '@media (min-width:900px)': {
//             fontSize: pxToRem(md),
//         },
//         '@media (min-width:1200px)': {
//             fontSize: pxToRem(lg),
//         },
//     };
// }
export function responsiveFontSizes({ xs, sm, md, lg }) {
    const styles = {};

    if (xs !== undefined) {
        styles["@media (min-width:0)"] = { fontSize: pxToRem(xs) };
    }
    if (sm !== undefined) {
        styles["@media (min-width:600px)"] = { fontSize: pxToRem(sm) };
    }
    if (md !== undefined) {
        styles["@media (min-width:1000px)"] = { fontSize: pxToRem(md) };
    }
    if (lg !== undefined) {
        styles["@media (min-width:1200px)"] = { fontSize: pxToRem(lg) };
    }

    return styles;
}

export const primaryFont = 'Public Sans, sans-serif';
export const secondaryFont = 'Barlow, sans-serif';
export const fontFamilyList = [
    'Arial',
    '-apple-system',
    // "BlinkMacSystemFont",
    // '"Segoe UI"',
    'Roboto',
    // '"Helvetica Neue"',
    // "sans-serif",
    // '"Apple Color Emoji"',
    // '"Segoe UI Emoji"',
    // '"Segoe UI Symbol"',
    'cursive',
];
// ----------------------------------------------------------------------

export const getTypography = ({ cFontSize = 14, cFontFamilyIndex = 5 }) => {
    return {
        // fontSize: cFontSize,
        // htmlFontSize: 16,
        // fontFamily: fontFamilyList[cFontFamilyIndex],
        // fontFamily: primaryFont,
        // fontSecondaryFamily: secondaryFont,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightSemiBold: 600,
        fontWeightBold: 700,

        fontFamily: `"Barlow", Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
        Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif`,
        
        fontFamilyCondensed: `"Barlow Condensed", Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
        Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif`,

        h1: {
            fontWeight: 700,
            fontSize: '3.5rem',
            lineHeight: 1.375,
        },
        h2: {
            fontWeight: 700,
            fontSize: '3rem',
            lineHeight: 1.375,
        },
        h3: {
            fontWeight: 700,
            fontSize: '2.25rem',
            lineHeight: 1.375,
        },
        h4: {
            fontWeight: 700,
            fontSize: '2rem',
            lineHeight: 1.375,
        },
        h5: {
            fontSize: '1.25rem', // 20px
            fontWeight: 600,
            lineHeight: '1.5rem', // 24px (120%)
        },
        h6: {
            fontSize: '1rem', // 16px
            fontWeight: 500,
            lineHeight: '1.5rem', // 24px (150%)
        },

        subtitle1: {
            fontSize: '1rem', // 16px
            fontWeight: 400,
            lineHeight: '1.5rem', // 24px (171.429%)
        },
        subtitle2: {
            //
            fontSize: '0.875rem', // 14px
            fontWeight: 500,
            lineHeight: 'normal',
        },
        body1: {
            fontSize: '1rem', // 16px
            fontWeight: 400,
            lineHeight: '1.2rem',
        },
        body2: {
            //
            fontSize: '0.75rem', // 12px
            fontWeight: 400,
            lineHeight: 'normal',
        },
        caption: {
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: 1.66,
        },
        overline: {
            fontSize: '1rem',
            fontWeight: 600,
            letterSpacing: '0.5px',
            lineHeight: 1,
        },
        button: {
            fontSize: '1rem', // 16px
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '1.5rem', // 24px (150%)
        },
        // headings
        heading1: {
            fontWeight: 700,
            fontSize: '32px',
            lineHeight: '100%',
            // ...responsiveFontSizes({ xs: 24, sm: 32 }),
        },
        heading2: {
            //1
            fontWeight: 700,
            fontSize: '24px',
            lineHeight: '100%',
            // ...responsiveFontSizes({sm:24})
        },
        heading3: {
            //1
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        subHeading: {
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        paraText1: {
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        paraText2: {
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        paraText3: {
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        paraText4: {
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        paraText5: {
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        paraText6: {
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '140%',
            // ...responsiveFontSizes({sm:24})
        },
        // ...........custom varibles..........
        customFontSize: {
            xxxSmall: '0.5rem', // 8px
            xxSmall: '0.625rem', // 10px
            xSmall: '0.75rem', // 12px
            small: '0.875rem', // 14px
            medium: '1rem', // 16px
            large: '1.125rem', // 18px
            xLarge: '1.25rem', // 20px
            xxLarge: '1.375rem', // 22px
            xxxLarge: '1.5rem', // 24px
            verylarge: '2rem',
        },

        borderRadius: {
            xxxSmall: '0.25rem', // 4px
            xxSmall: '0.375rem', // 6px
            xSmall: '0.5rem', // 8px
            small: '0.625rem', // 10px
            medium: '0.75rem', // 12px
            large: '0.875rem', // 14px
            xLarge: '1rem', // 16px
            xxLarge: '1.125rem', // 18px
            xxxLarge: '1.25rem', // 20px
            xxxxLarge: '1.375rem', // 22px
            xxxxxLarge: '1.5rem', // 24px
            round: '50%',
            none: '0rem',
            veryLarge: '3.125rem', //50px
        },
        generic: {
            xxxxSmall: '0.125rem', // 2px
            xxxSmall: '0.25rem', // 4px
            xxSmall: '0.375rem', // 6px
            xSmall: '0.5rem', // 8px
            small: '0.625rem', // 10px
            medium: '0.75rem', // 12px
            large: '0.875rem', // 14px
            xLarge: '1rem', // 16px
            xxLarge: '1.125rem', // 18px
            xxxLarge: '1.25rem', // 20px
            xxxxLarge: '1.375rem', // 22px
            xxxxxLarge: '1.5rem', // 24px
            none: '0rem',
            veryLarge: '3.125rem', //50px
            unset: 'unset',
        },
    };
};
